import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { withBackendUrl } from "./Utils/helpers";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-US",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: withBackendUrl(`/locales/{{lng}}/{{ns}}`),
      addPath: withBackendUrl(`/locales/add/{{lng}}/{{ns}}`),
      parse: (data) => {
        const parsedData = JSON.parse(data);

        const lng = Object.keys(parsedData)[0];
        if (parsedData[lng] && parsedData[lng].translation) {
          return parsedData[lng].translation;
        }
        // Fallback if structure is not as expected
        return parsedData;
      },
    },
    // Match your backend supported languages
    supportedLngs: ["en-US", "ja"]
  });

export default i18n;
